import { auth } from "../typings/auth";
import { STATE } from "../thor.const";

export class OrganizationRoutes {
    public static $inject: string[] = ["$stateProvider"];

    constructor($stateProvider: angular.ui.IStateProvider) {
        $stateProvider
            .state(STATE.ORGANIZATION.ABSTRACT, {
                abstract: true,
                url: "/etude",
                template: "<ui-view flex></ui-view>"
            })
            .state(STATE.ORGANIZATION.MAIN, {
                url: "",
                resolve: {
                    // initUser is injected here to ensure that it's resolved before resolving acl permission
                    checkAcl: [
                        "aclService",
                        "initUser",
                        aclService => aclService.isStateAllowed(auth.AclAccess.Organization)
                    ],
                    // v2 redirect
                    _: [
                        "$window",
                        ($window: ng.IWindowService) => $window.open(STATE.V2.ORGANIZATION.MAIN.url, "_self")
                    ]
                }
            })
            .state(STATE.ORGANIZATION.AUTHORIZATION, {
                url: "/appareils-autorises",
                resolve: {
                    // initUser is injected here to ensure that it's resolved before resolving acl permission
                    checkAcl: [
                        "aclService",
                        "initUser",
                        aclService => aclService.isStateAllowed(auth.AclAccess.Organization)
                    ],
                    // v2 redirect
                    _: [
                        "$window",
                        ($window: ng.IWindowService) => $window.open(STATE.V2.ORGANIZATION.AUTHORIZATION.url, "_self")
                    ]
                }
            })
            .state(STATE.ORGANIZATION.MY_PAGE, {
                url: "/ma-page",
                resolve: {
                    // initUser is injected here to ensure that it's resolved before resolving acl permission
                    checkAcl: [
                        "aclService",
                        "initUser",
                        aclService => {
                            return aclService.isStateAllowed(auth.AclAccess.Organization);
                        }
                    ],
                    // v2 redirect
                    _: [
                        "$window",
                        ($window: ng.IWindowService) => $window.open(STATE.V2.ORGANIZATION.MY_PAGE.url, "_self")
                    ]
                }
            });
    }
}
